import { FC } from "react";
import css from './index.module.css';
import * as Types from '../../types';
import { useNavigate } from "react-router-dom";

interface Container {
  uuid: string;
  name: string;
  domain: string;
  status: number;
  isAdmin?: boolean;
}

const SupportMini:FC<Container> = ({ uuid, name, domain, status, isAdmin = false }) => {
  const navigate = useNavigate();

  return (
    <div className={css.container} onClick={() => navigate(isAdmin ? `/admin/ticket/${uuid}` : `/support/${uuid}`)}>
        <div className={css.mainInfo}>
            <b>{name}</b>
            <a>{domain}</a>
        </div>
        <div className={css.status}>
          {status === 0 && <a style={{ background: "#0f4dca40" }}><i className="fi fi-rr-time-oclock"></i> На рассмотрении</a>}
          {status === 1 && <a style={{ background: "#cab40f40" }}><i className="fi fi-rr-envelope"></i> Есть ответ</a>}
          {status === 2 && <a style={{ background: "#33b07454" }}><i className="fi fi-rr-check-circle"></i> Решили</a>}
        </div>
    </div>
  );
};

export default SupportMini;